import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { buildingStore } from "store/Building/BuildingStore";
import { buildingDashboardStore } from "store/Building/BuildingDashboardStore";
import EmptyState from "components/EmptyState";
import { levelsDashboardStore } from "./LevelsDashboardStore";
import LifeCycleGwpCard from "./features/LifeCycleGwpCard";
import HotspotCard from "./features/HotspotCard";

const LevelsDashboard = () => {
  const { t, i18n } = useTranslation();
  const building = buildingStore.currentBuilding;
  const buildingId = building?.id;

  React.useEffect(() => {
    buildingDashboardStore.fetchGeneralEmissions(buildingId);
    buildingDashboardStore.checkB6HasReport();
    levelsDashboardStore.init(buildingId);

    return () => levelsDashboardStore.reset();
  }, [buildingId]);

  if (!buildingStore.buildingMappingStatus.hasReport) {
    return (
      <EmptyState
        type="inventory"
        loading={buildingStore.buildingMappingStatus.loading}
        containerClassName="m-6"
      />
    );
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-start mb-6 gap-4">
        <h1 className="text-xl font-semibold text-gray-900">
          {t("levels.title")}
        </h1>
        <div className="flex gap-6 text-sm text-gray-600 shrink-0">
          {building?.gross_floor_area != null && (
            <div className="text-right">
              <div className="text-xs text-gray-400">
                {t("levels.grossFloorArea")}
              </div>
              <div className="font-medium text-gray-800">
                {building.gross_floor_area.toLocaleString(i18n.language)} m²
              </div>
            </div>
          )}
          {building?.life_span != null && (
            <div className="text-right">
              <div className="text-xs text-gray-400">
                {t("levels.lifeSpan")}
              </div>
              <div className="font-medium text-gray-800">
                {building.life_span} {t("levels.years")}
              </div>
            </div>
          )}
        </div>
      </div>
      <LifeCycleGwpCard />
      <HotspotCard />
    </div>
  );
};

export default observer(LevelsDashboard);
